// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal {
  overflow: visible;
}
.custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal .header {
  padding: 15px 20px 4px 15px;
}
.custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal .body {
  height: 100%;
  overflow-y: initial;
}
.custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal .footer {
  padding-top: 20px;
  padding-bottom: 15px;
}
.conference-info[data-v-6ba0f67a] {
  position: fixed;
  color: var(--toolbtn-color);
  font-size: 16px;
  height: 240px;
  width: 423px;
  margin: 0 auto;
}
.conference-info[data-v-6ba0f67a] .non-border-input {
  width: 100%;
}
.conference-info .conf-item[data-v-6ba0f67a] {
  display: flex;
  align-items: flex-end;
  height: 70px;
}
.conference-info .conf-modes[data-v-6ba0f67a] {
  flex-direction: row;
  justify-content: space-between;
}
.conference-info .date-picker-input-from[data-v-6ba0f67a],
.conference-info .date-picker-input-to[data-v-6ba0f67a] {
  background-color: inherit;
}
.conference-info .subject .custom-input-text[data-v-6ba0f67a] {
  width: 100%;
}
.conference-info .custom-input-text-placeholder[data-v-6ba0f67a] {
  color: var(--modal-text-color) !important;
}
.conference-info .conf-auth[data-v-6ba0f67a] {
  flex-direction: row;
}
.conference-info .conf-settings[data-v-6ba0f67a] {
  align-items: center;
  padding-top: 41px;
}
.conference-info .conf-settings a[data-v-6ba0f67a] {
  color: var(--modal-elem-color);
  cursor: pointer;
}
.conference-info .conf-settings a[data-v-6ba0f67a]:hover {
  color: var(--modal-elem-color);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/editConference.vue"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB","sourcesContent":[".custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal {\n  overflow: visible;\n}\n.custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal .header {\n  padding: 15px 20px 4px 15px;\n}\n.custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal .body {\n  height: 100%;\n  overflow-y: initial;\n}\n.custom-modal[data-v-6ba0f67a] .v--modal-box.v--modal .footer {\n  padding-top: 20px;\n  padding-bottom: 15px;\n}\n.conference-info[data-v-6ba0f67a] {\n  position: fixed;\n  color: var(--toolbtn-color);\n  font-size: 16px;\n  height: 240px;\n  width: 423px;\n  margin: 0 auto;\n}\n.conference-info[data-v-6ba0f67a] .non-border-input {\n  width: 100%;\n}\n.conference-info .conf-item[data-v-6ba0f67a] {\n  display: flex;\n  align-items: flex-end;\n  height: 70px;\n}\n.conference-info .conf-modes[data-v-6ba0f67a] {\n  flex-direction: row;\n  justify-content: space-between;\n}\n.conference-info .date-picker-input-from[data-v-6ba0f67a],\n.conference-info .date-picker-input-to[data-v-6ba0f67a] {\n  background-color: inherit;\n}\n.conference-info .subject .custom-input-text[data-v-6ba0f67a] {\n  width: 100%;\n}\n.conference-info .custom-input-text-placeholder[data-v-6ba0f67a] {\n  color: var(--modal-text-color) !important;\n}\n.conference-info .conf-auth[data-v-6ba0f67a] {\n  flex-direction: row;\n}\n.conference-info .conf-settings[data-v-6ba0f67a] {\n  align-items: center;\n  padding-top: 41px;\n}\n.conference-info .conf-settings a[data-v-6ba0f67a] {\n  color: var(--modal-elem-color);\n  cursor: pointer;\n}\n.conference-info .conf-settings a[data-v-6ba0f67a]:hover {\n  color: var(--modal-elem-color);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
